import { FC, PropsWithChildren } from 'react'

import { useSVGPlane } from 'features/hex-board/svg-plane/use-svg-plane'

export const SVGPlane: FC<PropsWithChildren> = ({ children }) => {
  const {
    svgRef,
    viewBox,
    containerRef,
    // handleWheel,
    //  stopDrag,
    //   startDrag,
    //    handleDrag
  } = useSVGPlane()

  const containerWidth = containerRef.current?.clientWidth ?? 0
  const containerHeight = containerRef.current?.clientHeight ?? 0

  const style = {
    width: containerWidth < containerHeight ? containerWidth : 'auto',
    height: containerHeight < containerWidth ? containerHeight : 'auto',
  }

  return (
    <div
      ref={containerRef}
      // onWheel={handleWheel}
      // onPointerUp={stopDrag}
      // onPointerDown={startDrag}
      // onPointerMove={handleDrag}
      // onPointerCancel={stopDrag}
      className="flex flex-1 items-center justify-center overflow-hidden"
    >
      <svg ref={svgRef} viewBox={viewBox} style={style} className="overflow-visible">
        {children}
      </svg>
    </div>
  )
}
